import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../static/css/VerifyEmail.css';
import logo from '../static/images/images/a-logo-transperent.png';

class VerifyEmailInner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: 'loading',
            message: '',
            isIOS: false
        };
    }

    componentDidMount() {
        const userAgent = navigator.userAgent || navigator.vendor || '';
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        this.setState({ isIOS });

        this.verifyEmail();
    }

    async verifyEmail() {
        const { id, token } = this.props.params;

        try {
            const response = await axios.get(
                process.env.REACT_APP_SERVER_API + `/auth/verify-email/${id}/${token}`
            );

            if (response.data.message === 'Email already verified.') {
                this.setState({ status: 'already_verified', message: response.data.message });
            } else {
                this.setState({ status: 'success', message: response.data.message });
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                const errorMsg = error.response.data.error || '';
                if (errorMsg.toLowerCase().includes('expired')) {
                    this.setState({ status: 'expired', message: errorMsg });
                } else {
                    this.setState({ status: 'error', message: errorMsg });
                }
            } else {
                this.setState({ status: 'error', message: 'Something went wrong. Please try again.' });
            }
        }
    }

    renderContent() {
        const { status, isIOS } = this.state;

        if (status === 'loading') {
            return (
                <div className="verify-email-content">
                    <div className="verify-email-spinner"></div>
                    <p className="verify-email-message">Verifying your email...</p>
                </div>
            );
        }

        if (status === 'success') {
            return (
                <div className="verify-email-content">
                    <div className="verify-email-icon verify-email-icon-success">&#10003;</div>
                    <p className="verify-email-message">Your email has been verified!</p>
                    <p className="verify-email-submessage">You can now enjoy all the features of AniMates.</p>
                    {isIOS
                        ? <a href="animates://" className="verify-email-button">Open AniMates</a>
                        : <p className="verify-email-close-message">You may close this window now.</p>
                    }
                </div>
            );
        }

        if (status === 'already_verified') {
            return (
                <div className="verify-email-content">
                    <div className="verify-email-icon verify-email-icon-success">&#10003;</div>
                    <p className="verify-email-message">Your email is already verified!</p>
                    {isIOS
                        ? <a href="animates://" className="verify-email-button">Open AniMates</a>
                        : <p className="verify-email-close-message">You may close this window now.</p>
                    }
                </div>
            );
        }

        if (status === 'expired') {
            return (
                <div className="verify-email-content">
                    <div className="verify-email-icon verify-email-icon-error">&#10007;</div>
                    <p className="verify-email-message">This verification link has expired.</p>
                    <p className="verify-email-submessage">Please open the AniMates app and request a new verification email from your profile settings.</p>
                </div>
            );
        }

        // error
        return (
            <div className="verify-email-content">
                <div className="verify-email-icon verify-email-icon-error">&#10007;</div>
                <p className="verify-email-message">Something went wrong.</p>
                <p className="verify-email-submessage">The verification link may be invalid. Please try again or request a new one from the app.</p>
            </div>
        );
    }

    render() {
        return (
            <div className="verify-email-container">
                <div className="animates-logo-container"><img className="animates-logo" src={logo} alt="AniMates Logo" /></div>
                {this.renderContent()}
                <p className="verify-email-footer">© 2026 AniMates. All rights reserved.</p>
            </div>
        );
    }
}

// Wrapper to pass React Router v6 params to class component
function VerifyEmail() {
    const params = useParams();
    return <VerifyEmailInner params={params} />;
}

export default VerifyEmail;
